import React, { useState, useEffect } from 'react';
import { ChevronDown, Menu, X, Sparkles } from 'lucide-react';
import { NAV_LINKS } from '../mock';

const Logo = () => (
  <a href="#" className="flex items-center gap-2 group">
    <div className="relative w-11 h-11 rounded-xl bg-[#22c55e] flex items-center justify-center shadow-[0_4px_12px_rgba(34,197,94,0.45)] group-hover:rotate-12 transition-transform duration-500">
      <div className="absolute inset-1 rounded-lg bg-black flex items-center justify-center">
        <span className="text-[#22c55e] font-black text-lg tracking-tighter">X</span>
      </div>
    </div>
    <div className="leading-tight">
      <div className="font-black text-[22px] tracking-tight text-black">Xxpand<span className="text-[#22c55e]">.</span>io</div>
      <div className="text-[9px] uppercase tracking-[0.15em] text-neutral-500 font-semibold">Streamline. Automate. Grow.</div>
    </div>
  </a>
);

const Dropdown = ({ link }) => {
  if (!link.columns && !link.items) return null;
  return (
    <div className="nav-dropdown absolute top-full left-1/2 -translate-x-1/2 mt-3 z-50">
      <div className="bg-white rounded-2xl shadow-2xl border border-neutral-100 p-6 min-w-[280px]">
        {link.columns ? (
          <div className="grid grid-cols-2 gap-6 min-w-[640px]">
            {link.columns.map((col) => (
              <div key={col.heading}>
                <div className="text-sm font-bold text-black mb-3 pb-2 border-b border-neutral-100">{col.heading}</div>
                <ul className="space-y-1.5">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a href="#" className="text-[13px] text-neutral-600 hover:text-black hover:bg-[#dcfce7] px-2 py-1.5 rounded-md block transition-colors">
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <ul className="space-y-1">
            {link.items.map((it) => (
              <li key={it}>
                <a href="#" className="text-sm text-neutral-700 hover:text-black hover:bg-[#dcfce7] px-3 py-2 rounded-md block transition-colors">
                  {it}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white/80 backdrop-blur-sm'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="h-[76px] flex items-center justify-between">
          <Logo />

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <div key={link.label} className="nav-item">
                <button className="flex items-center gap-1 text-[14px] font-semibold text-neutral-800 hover:text-black px-4 py-2 rounded-lg hover:bg-neutral-50 transition-colors">
                  {link.label === 'Ecosystem' && <Sparkles className="w-3.5 h-3.5 text-[#22c55e]" />}
                  {link.label}
                  {(link.items || link.columns) && <ChevronDown className="w-3.5 h-3.5 opacity-60" />}
                </button>
                <Dropdown link={link} />
              </div>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href="#" className="px-6 py-2.5 rounded-full font-semibold text-sm border-2 border-[#22c55e] text-black hover:bg-[#22c55e] transition-colors">
              Log in
            </a>
          </div>

          <button className="lg:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileOpen && (
          <div className="lg:hidden border-t border-neutral-100 py-4">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href="#" className="block px-3 py-2.5 text-sm font-semibold text-neutral-800 hover:bg-neutral-50 rounded-lg">
                {l.label}
              </a>
            ))}
            <a href="#" className="block mt-2 mx-3 text-center px-6 py-2.5 rounded-full font-semibold text-sm border-2 border-[#22c55e] text-black">
              Log in
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
